function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOpenStock = function SvgOpenStock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    viewBox: "0 0 512 512",
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M392.891 242.125H183.234V128.344c.016-20.188 8.094-38.219 21.313-51.469C217.813 63.656 235.828 55.578 256 55.563c20.172.016 38.188 8.094 51.453 21.313 13.219 13.25 21.297 31.281 21.313 51.469v45.75h55.563v-45.75c.016-35.359-14.406-67.625-37.578-90.75C323.609 14.406 291.344-.016 256 0c-35.344-.016-67.609 14.406-90.75 37.594-23.172 23.125-37.594 55.391-37.578 90.75v113.781h-8.563c-31.078 0-56.266 25.172-56.266 56.25V455.75c0 31.063 25.188 56.25 56.266 56.25H392.89c31.078 0 56.266-25.188 56.266-56.25V298.375c0-31.078-25.187-56.25-56.265-56.25zM272.266 394.469l8.859 57.438h-50.25l8.859-57.438c-13.969-6.25-23.75-20.219-23.75-36.5 0-22.094 17.922-40.031 40-40.031 22.109 0 40.031 17.938 40.031 40.031.001 16.281-9.781 30.25-23.749 36.5z",
    style: {
      fill: "#000"
    }
  }));
};
export default SvgOpenStock;